export default __webpack_public_path__ + "static/zonapro-bold-0a770ef9829c61558ee524c8a4e7628a.woff";